
export default {
  SET_REPORTS(state, data) {
    state.reports = data;
  },
  SET_START_DATETIME(state, data) {
    state.startDateTime = data;
  },
  SET_END_DATETIME(state, data) {
    state.endDateTime = data;
  },
  SET_SEARCH_PARAMETERS(state, data) {
    state.searchParameters = data;
  },
  SET_CURRENT_PAGE(state, data) {
    state.currentPage = data;
  },
  SET_CONDITION_VESSELS(state, data) {
    state.searchConditionVessels = data;
  },
  SET_CONDITION_SENDERS(state, data) {
    state.searchConditionSenders = data;
  },
  SET_CONDITION_STATUS_LABELS(state, data) {
    state.searchConditionStatusLabels = data;
  },
  SET_TOTAL_REPORT_COUNT(state, data) {
    state.totalReportCount = data;
  },
  SET_TOTAL_PAGE(state, data) {
    state.totalPage = data;
  },
  SET_FORMS(state, data) {
    state.forms = data;
  },

  SET_SELECT_FORM_VESSEL_NAME_PROPS(state, data) {
    state.selectFormVesselNameProps = data;
  },

  SET_SELECTED_VESSEL_NAMES(state, data) {
    state.selectedVesselNames = data;
  },

  SET_SELECT_FORM_SENDER_PROPS(state, data) {
    state.selectFormSenderProps = data;
  },

  SET_SELECTED_SENDERS(state, data) {
    state.selectedSenders = data;
  },

  SET_SELECT_FORM_STATUS_PROPS(state, data) {
    state.selectFormStatusProps = data;
  },

  SET_SELECTED_STATUS(state, data) {
    state.selectedStatus = data;
  },

  SET_DATE_RANGE(state, data) {
    state.dateRange = data;
  },

  STATUS_COLOR_MAPPING(state, data) {
    state.statusColorMapping = data;
  },

  RESET_STATE(state, data) {
    Object.assign(state, data)
  },
}
